export default {
    loadingPageText: "Please wait while your page loads...",
    loadingPageTextAlt: "Loading {{resource}}",
    activeSubscriptionLabel: "Active Subscription",
    activeSubscriptionEndDateLabel: "Ends {{date}}",
    cancelSubscriptionLabel: "Cancel Subscription",
    cancelSubscriptionNotice: "If you cancel your subscription now, you will still have access till {{renewalDate}}",
    cancelSubscriptionConfirmationMessage: "Are you sure you want to cancel your {{subscriptionName}} plan. Enter your password to confirm ?",
    testCompletedTitle: "Test Completed",
    testCompletedDescription: "Great job! You've completed the test. Your answers have been submitted successfully.",
    testQuestionsLabel: "Questions",
    answeredQuestionLabel: "Answered",
    timeUsedLabel: "Time Used",
    returnLabel: "Return",
    goToDashboard: "Go to Dashboard",
    notFoundTitle: "The page you were looking for doesn't exist.",
    notFoundDescription: "The page may have been moved or removed.",
    notFoundActionLabel: "Back to home",
    serverErrorTitle: "Something went wrong on our side.",
    serverErrorDescription: "An unexpected error occurred. Please reload the page, or try again in a moment.",
    serverErrorReloadActionLabel: "Reload page",
    testProgressLabel: "Progress: {{progress}}/{{total}} answered",
    testProgressPercentageLabel: "{{percentage}}% complete",
    readingPassageLabel: "Reading passage",
    leaveTestLabel: "Leave test",
    leaveTestMessage: "You are about to leave this test. Confirm?",
    disableTimerActionLabel: "Disable",
    enableTimerActionLabel: "Enable",
    toggleTimerLabel: "{{action}} timer",
    submitTestActionButtonLabel: "Submit Test",
    emptyRecentTestDescription: "Tests you completed before will be visible here",
    practiceModeSelectionTitle: "Select practice mode",
    mockTestSelectionTitle: "Mock Test",
    mockTestSelectionDescription: "Simulate real test conditions with strict time limits. \n Build your test-taking stamina and strategy",
    strictTimeEnforcementTitle: "Strict Time Enforcement",
    strictTimeEnforcementDescription: "Timer is mandatory and will auto-submit when time expires. Mimics actual test conditions.",
    startMockTestActionButtonLabel: "Start Mock Test",
    exerciseModeSelectionTitle: "Exercise",
    exerciseModeSelectionDescription: "Practice at your own pace without time pressure. \n Perfect for learning and skill development.",
    noTimeEnforcementTitle: "No Time Enforcement",
    noTimeEnforcementDescription: "Take as much time as you need to understand each question. Timer is optional but won't auto-submit.",
    startExerciseModeActionButtonLabel: "Start Exercise",
    noResultsTitle: "No test results available",
    noResultsDescription: "All your results on tests you completed will be visible here. Take a test to see your results.",
    noResultsActionLabel: "Take a test",

    testInstructionsNotice: "Please review the instructions carefully before beginning your test",
    hideTestInstructionsMessage: "Do not show this next time",
    startTestActionButtonLabel: "Start Test",
    nextInstructionsPageActionButtonLabel: "Next",
    previousInstructionsPageActionButtonLabel: "Previous",
    instructionPageLabel: "Page {{page}} of {{pageCount}}",
    generalInstructionPageTitle: "Welcome to your LinguaScore Test Room",
    generalInstructionPageDescription: "Let's review test details and configure test preferences",
    totalQuestionCountLabel: "Total Questions",
    timeAllowedLabel: "Time Allowed",
    enableTimerTitle: "Enable Timer",
    enableTimerDescription: "Challenge yourself with a countdown timer",
    mockTestDisableTimerNotice: "Cannot disable Timer of a Mock Test",
    generalInstructionsProTipMessage: "Pro Tip: Review all instruction pages before starting your test. This will help you understand the test format and requirements.",
    navigationInstructionsPageTitle: "Test Navigation & Guidelines",
    navigationInstructionsPageDescription: "Learn how to navigate through the test and manage your answers",
    navigationInstructionsNavigationSectionTitle: "Navigation",
    navigationInstruction: "Use Previous/Next buttons to move between questions",
    navigationInstructionsAnswersSectionTitle: "Answers",
    answerInstruction1: "Change your answers anytime before submitting",
    answerInstruction2: "Review your progress in the navigator panel",
    submissionInstruction: "Remember: You must click \"Submit Test\" when finished",
    submissionNotice: "The test will auto-submit when time expires if timer is enabled. Once submitted, you cannot modify your answers.",
    systemRequirementsTitle: "System Requirements",
    systemRequirementsDescription: "Ensure your system meet these requirements for best experience.",
    systemRequirementsBrowserTitle: "Browser",
    systemRequirementRecommendedBrowserLabel: "recommended",
    systemRequirementDisplayTitle: "Display",
    systemRequirementDisplayResolution: "Minimum 1024x768 resolution",
    systemRequirementDisplayFullScreenRecommendation: "Full screen recommended",
    systemRequirementDisplayZoomLevel: "Zoom level at 100%",
    systemRequirementLighting: "Good lighting conditions",
    callToStartTestActionLabel: "Ready to begin?",
    callToStartTestActionNotice: "By clicking \"Start Test\" below, you acknowledge that you have:",
    callToStartTestActionNotice1: "Read and understood all instructions",
    callToStartTestActionNotice2: "Verified your systems meets the requirements",
    callToStartTestActionNotice3: "Are ready to take the test without interruptions",

    testSubmissionLoadingMessage: "Submitting your test, this may take a while...",
    confirmDialogActionButtonLabel: "Confirm",
    cancelDialogActionButtonLabel: "Cancel",

    accountUpdateSuccessMessage: "Profile successfully updated",
    unknownErrorMessage: "An unknown error has occurred. Please retry",
    loadingErrorMessage: "Unable to load {{label}}. You might want to retry.",
    submitErrorMessage: "Unable to submit {{label}}. You might want to retry.",
    retryActionLabel: "Retry",

    enableNotificationDialogTitle: "Stay on top of your progress",
    enableNotificationDialogDescription: "Receive instant notifications when your test is graded so you can review your feedback and keep improving without missing a beat.",
    enableNotificationActionButtonLabel: "Notify me",

    hidePreTestInstructionsLabel: "Do not show this next time",
    speakingTestUploadLabel: "Uploading your answers...",
    speakingTestUploadFailedMessage: "Error uploading your answers. Please try again.",
    allowMicrophoneAccessWarningMessage: "Please allow Microphone access to continue.",
    allowMicPrompt: "You must grant microphone access",
    allowMicActionButtonLabel: "Allow Microphone",
    speakingPartTwoCountdownLabel: "Start speaking in {{seconds}}",

    paymentCancelledTitle: "Payment cancelled",
    paymentCancelledDescription: "Your payment has been cancelled. Please try again",
    paymentFailedTitle: "Payment failed",
    paymentFailedDescription: "Your payment has failed maybe due to a network or insufficient balance. Check your account and try again",
    paymentSuccessTitle: "Payment success",
    paymentSuccessDescription: "Your payment was successful, you can now leave this screen",
    paymentPendingTitle: "Waiting for payment",
    paymentPendingDescription: "Your payment has been initiated and needs validation. We are confirming it with Ikeepay, this usually takes a few seconds",
    closePaymentStatusDialogActionLabel: "Close",

    notificationsTitle: "Notifications",
    notificationsDescription: "See notifications about account activity and test results all in one place",
    emptyNotificationsText: "Your notifications show up here",
    notificationItemActionLabel: "Mark as read",
    plainLoadingText: "Please wait...",
    defaultLoadingErrorMessage: "An error has occurred. Please try again.",
    resultFeedbackPositiveActionLabel:"View results",
    resultFeedbackNegativeActionLabel:"Dismiss",
    paymentProcessingNotice:"Your payment may take up to 5 mins to be processed after it has been approved.",

    /**
     * Server error codes.
     *
     * Keys mirror the `ErrorCode` enum in backend/src/utils/ErrorCodes.ts and are
     * the exact `messageCode` values the API returns, so a response is rendered with
     * `t(response.messageCode, {field: response.field})` — no mapping table.
     */
    OPERATION_SUCCESSFUL: "Operation successful.",
    REQUEST_INVALID: "Your request is invalid or malformed. Please try again.",
    RESOURCE_NOT_FOUND: "We are unable to find this resource.",
    AUTHENTICATION_REQUIRED: "You must be signed in to continue.",
    ACCESS_FORBIDDEN: "You are not authorized to access this resource.",
    INTERNAL_ERROR: "An unknown error has occurred. Please try again.",

    FIELD_REQUIRED: "'{{field}}' is required.",
    FIELD_INVALID_TYPE: "'{{field}}' has an unexpected format.",
    FIELD_NOT_UNIQUE: "This '{{field}}' is already taken.",
    FIELD_NOT_UNIQUE_email: "This email address is already taken.",
    FIELD_MAX_VALUE_EXCEEDED: "'{{field}}' is above the allowed maximum.",
    FIELD_MIN_VALUE_REQUIRED: "'{{field}}' is below the allowed minimum.",
    FIELD_TOO_LONG: "'{{field}}' is too long.",
    FIELD_TOO_SHORT: "'{{field}}' is too short.",
    FIELD_VALUE_NOT_ALLOWED: "This value is not allowed for '{{field}}'.",
    FIELD_REFERENCE_NOT_FOUND: "The '{{field}}' you selected no longer exists.",
    FIELD_EMPTY: "'{{field}}' cannot be empty.",
    FIELD_ARRAY_ITEM_INVALID: "One of the entries in '{{field}}' is invalid.",
    FIELD_NESTED_INVALID: "Some details in '{{field}}' are invalid.",
    FIELD_PREFIX_REQUIRED: "'{{field}}' does not start with the expected value.",
    FIELD_SUFFIX_REQUIRED: "'{{field}}' does not end with the expected value.",
    FIELD_VALUES_NOT_MATCHING: "'{{field}}' does not match.",
    FIELD_PASSWORD_NOT_MATCHING: "Passwords do not match.",

    USER_INVALID_CREDENTIALS: "Email or password is incorrect. Please try again.",
    USER_PASSWORD_INCORRECT: "Password incorrect, please try again.",
    USER_OLD_PASSWORD_INCORRECT: "Your current password is incorrect, please try again.",
    USER_IDENTICAL_PASSWORD: "Your new password cannot be the same as your old one.",
    USER_ACCOUNT_DISABLED: "Your account has been disabled. Please contact support to recover it.",
    USER_EMAIL_UNAVAILABLE: "This email is not available.",
    USER_EMAIL_NOT_FOUND: "This email does not match any registered account.",
    USER_EMAIL_NOT_VERIFIED: "You need to verify your email address to proceed.",
    USER_PROVIDER_ACCOUNT_NOT_FOUND: "No account is associated with this sign-in provider.",
    USER_ACCOUNT_NOT_RESOLVED: "We could not open your account. Please try signing in again.",
    USER_INVALID_TOKEN: "Your session is invalid. Please sign in again.",
    USER_TOKEN_EXPIRED: "Your session has expired. Please sign in again.",
    SESSION_EXPIRED: "Your session has expired, please try again.",

    EXAM_NOT_AVAILABLE: "This exam is not available yet. Please choose another one.",
    EXAM_UNKNOWN: "We do not recognise this exam. Please choose another one.",
    REGION_NOT_SUPPORTED: "This region is not supported yet.",
    SUBSCRIPTION_REQUIRED: "An active subscription is required to continue.",
    ACCOUNT_INSUFFICIENT_BALANCE: "Insufficient balance, please top up and retry.",
    ELEVATED_ROLE_REQUIRED: "You do not have the required permissions for this action."
    ,
    USER_EMAIL_ALREADY_VERIFIED: "This email address is already verified.",
    USER_EMAIL_VERIFICATION_REQUIRED: "Please verify your email address to continue.",
    LINK_INVALID: "This link is invalid or has already been used.",
    LINK_EXPIRED: "This link has expired. Please request a new one.",
    PASSWORD_RESET_EMAIL_SENT: "If that email matches an account, we've sent a reset link. Please check your inbox.",
    PASSWORD_RESET_SUCCESSFUL: "Your password has been reset. You can now sign in.",
    EMAIL_VERIFICATION_SENT: "Verification email sent. Please check your inbox.",
    EMAIL_VERIFICATION_SUCCESSFUL: "Your email address has been verified.",
    ACCOUNT_DELETED: "Your account has been deleted.",
    USER_DELETION_NOT_CONFIRMED: "That doesn't match. Please check and try again.",
    USER_ADMIN_DELETION_FORBIDDEN: "Admin accounts can't be deleted from here.",
    USER_SELF_DELETION_FORBIDDEN: "You can't delete your own account from here.",
    FREE_TRIAL_UNAVAILABLE: "You have already used your free trial. Choose a plan to continue.",
    SUBSCRIPTION_NOT_AVAILABLE_IN_REGION: "This plan isn't available in your region. Please choose another plan.",
    TRANSACTION_ALREADY_COMPLETED: "This payment has already been processed.",
    PARTNER_ROLE_REQUIRED: "This area is reserved for LinguaScore partners."
}
